"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _siteSelectorContext = require("./../context/site-selector-context");

var _siteSelectorComponents = require("./site-selector-components");

var _useResponsiveQuery = require("@eig-builder/core-utils/hooks/useResponsiveQuery");

var SiteSelector = function SiteSelector() {
  var _useSiteSelector = (0, _siteSelectorContext.useSiteSelector)(),
      sites = _useSiteSelector.sites,
      site = _useSiteSelector.site;

  var dispatch = (0, _siteSelectorContext.useSiteSelectorDispatch)();

  var _useState = (0, _react.useState)([]),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      menuItems = _useState2[0],
      setMenuItems = _useState2[1];

  var isMobile = (0, _useResponsiveQuery.useIsMobile)();
  (0, _react.useEffect)(function () {
    if (sites) {
      var result = [/*#__PURE__*/_react["default"].createElement(_siteSelectorComponents.Group, {
        key: 1
      }, sites.map(function (site) {
        return /*#__PURE__*/_react["default"].createElement(_siteSelectorComponents.GroupItem, {
          key: site.id,
          site: site,
          dataElementIdPrefix: "navigation-site-selector-site-".concat(site.id),
          onItemClick: function onItemClick() {
            return dispatch({
              type: 'setSite',
              payload: site
            });
          }
        });
      }))];
      setMenuItems(result);
    }
  }, [dispatch, sites]);
  return /*#__PURE__*/_react["default"].createElement(_siteSelectorComponents.Menu, {
    currentSite: site,
    sites: sites,
    isMobile: isMobile
  }, menuItems);
};

var _default = (0, _react.memo)(SiteSelector);

exports["default"] = _default;